import listActions from 'src/modules/watchlist/list/watchlistListActions';
import WatchlistService from 'src/modules/watchlist/watchlistService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'WATCHLIST_DESTROY';

const watchlistDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistDestroyActions.DESTROY_STARTED,
      });

      await WatchlistService.destroyAll([id]);

      dispatch({
        type: watchlistDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.watchlist.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/watchlist');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: watchlistDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistDestroyActions.DESTROY_ALL_STARTED,
      });

      await WatchlistService.destroyAll(ids);

      dispatch({
        type: watchlistDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.watchlist.destroyAll.success'),
      );

      getHistory().push('/watchlist');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: watchlistDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default watchlistDestroyActions;
